import { render, staticRenderFns } from "./OrderSuggestions.vue?vue&type=template&id=2be3634c&scoped=true&"
import script from "./OrderSuggestions.vue?vue&type=script&lang=js&"
export * from "./OrderSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./OrderSuggestions.vue?vue&type=style&index=0&id=2be3634c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be3634c",
  null
  
)

export default component.exports